<template>
    <div>
        <el-container direction="vertical">
            <el-card shadow="never" style="margin-left: 0px;" :body-style="{ padding: '10px' }">
                <el-row style="margin-bottom: 0px;margin-top: 10px;">
                    <el-row>
                        <div>
                            <el-col :span="24">
                                <el-card style="margin: 0 0 10px 5px; min-height: 380px; height: auto;">
                                    <div slot="header" class="clearfix" style="font-weight: 700;">
                                        <span>风险预警</span>
                                    </div>
                                    <el-row style="margin-bottom: 8px;">
                                        <el-input style="width: 200px;" v-model="riskPatientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-input style="width: 180px; margin-left: 10px;" v-model="riskRecordNo">
                                            <template slot="prepend">登记号</template>
                                        </el-input>
                                        <span style="margin-left: 16px;color: #909399;font-size: 14px;">来源：</span>
                                        <el-select style="width: 140px;margin-left: 0px;" v-model="riskFromSource"
                                            placeholder="请选择" clearable>
                                            <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 14px;color: #909399;font-size: 14px;">科室：</span>
                                        <el-select style="width: 200px;margin-left: 0px;" v-model="riskDeptIds"
                                            multiple filterable clearable placeholder="请选择科室（可多选）">
                                            <el-option v-for="x in deptsOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 14px;color: #909399;font-size: 14px;">检测时间：</span>
                                        <el-date-picker v-model="riskDateRange" type="daterange" align="right"
                                            unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                        <el-button type="primary" style="margin-left: 16px;"
                                            @click="getRiskList">查询</el-button>
                                        <el-button type="primary" plain style="margin-left: 10px;"
                                            @click="handleResetRisk">重置</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="riskListLoading" :data="riskList" height="180px" fit
                                            highlight-current-row style="width: 100%; margin-top: 0px"
                                            :show-header="false">
                                            <el-table-column width="50px" align="left">
                                                <template slot-scope="scope">
                                                    <!-- <i class="el-icon-warning risk-icon"></i> -->
                                                    <el-avatar
                                                        :style="{ backgroundColor: !scope.row.msgStatus ? 'red' : '' }"
                                                        shape="square" size="medium">{{ scope.row.refType
                                                        }}</el-avatar>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="300px" align="left">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.applyDiagnosis }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="130px" align="left">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row.refTime) }}</span>
                                                </template>
                                            </el-table-column>

                                            <!-- <el-table-column width="50px" align="left">
                                                <template slot-scope="scope">
                                                    <el-tag v-if="scope.row.msgStatus ? false : true" size="mini"
                                                        effect="dark" type="danger">new</el-tag>
                                                </template>
                                            </el-table-column> -->
                                            <el-table-column align="center" label="操作" width="60" fixed="right">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientWarnMessageList(scope.row)">
                                                        查看
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="riskTotal > 0" :total="riskTotal"
                                            :page.sync="riskListQuery.pageNum" :limit.sync="riskListQuery.pageSize"
                                            @pagination="getRiskList" :small="true" />
                                        <patientWarnMessageDialog v-if="patientWarnMessageDialogVisible"
                                            ref="patientWarnMessageDialogRef">
                                        </patientWarnMessageDialog>
                                    </el-row>
                                </el-card>
                            </el-col>

                        </div>
                    </el-row>

                    <el-row>
                        <el-card class="customCard">
                            <el-row>

                                <el-col :span="4" style="margin-right: 16px;">
                                    <el-badge :value="countCodiag" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '2' && 'cardColorSkyBlue'"
                                            style="width: 200px;height: 80px;cursor: pointer;border-radius: 8px;user-select: none;"
                                            @click.native="handleTabsClick({ name: '2', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="5">
                                                    <img src="../../assets/images/p2.png" alt="">
                                                </el-col>
                                                <el-col :span="19">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        协诊任务
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>

                                <el-col :span="4" style="margin-right: 16px;">
                                    <el-badge :value="countFollowup" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '5' && 'cardColorSkyBlue'"
                                            style="width: 180px;height: 80px;border-radius: 8px;cursor: pointer;user-select: none;"
                                            @click.native="handleTabsClick({ name: '5', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="8">
                                                    <img src="../../assets/images/p5.png" alt="">
                                                </el-col>
                                                <el-col :span="16">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        复查通知
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>

                                <el-col :span="4" style="margin-right: 16px;">
                                    <el-badge :value="countIntegrateService" class="item">
                                        <el-card class="cardColorDefault"
                                            :class="activeName === '4' && 'cardColorSkyBlue'"
                                            style="width: 200px;height: 80px;cursor: pointer;border-radius: 8px;user-select: none;"
                                            @click.native="handleTabsClick({ name: '4', type: 'click' })">
                                            <el-row style="margin-top: 10px;">
                                                <el-col :span="5">
                                                    <img src="../../assets/images/p4.png" alt="">
                                                </el-col>
                                                <el-col :span="19">
                                                    <div
                                                        style="font-size: 21px; color: #fff; font-weight: bold;margin-top: 2px;">
                                                        患者待管理
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-badge>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-row>

                    <el-row>
                        <el-card class="elCard" style="margin: 0px 5px 10px 0px;">
                            <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="协诊任务" name="2">
                                    <el-row>
                                        <el-input style="width: 220px;" v-model="listQuery1.patientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-input style="width: 200px; margin-left: 14px;"
                                            v-model="listQuery1.recordNo">
                                            <template slot="prepend">登记号</template>
                                        </el-input>
                                        <span style="margin-left: 20px;color: #909399;font-size: 14px;">来源：</span>
                                        <el-select style="width: 160px;margin-left: 0px;"
                                            v-model="listQuery1.fromSource" placeholder="请选择">
                                            <el-option v-for="x in sourceOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">科室：</span>
                                        <el-select style="width: 220px;margin-left: 0px;" v-model="deptIds1" multiple
                                            filterable clearable placeholder="请选择科室（可多选）">
                                            <el-option v-for="x in deptsOptions" :key="x.value" :label="x.label"
                                                :value="x.value">
                                            </el-option>
                                        </el-select>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">检测时间：</span>
                                        <el-date-picker v-model="valueData1" type="daterange" align="right"
                                            unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                        </el-date-picker>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '2' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="listLoading" :data="list1" height="310px" border fit
                                            highlight-current-row style="width: 100%; margin-top: 20px">
                                            <el-table-column width="100px" align="center" label="姓名">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.patientName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="登记号">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.recordNo || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="60px" align="center" label="性别">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="60px" align="center" label="年龄">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="115px" align="center" label="联系方式">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="病理类型">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row?.inhosLungInfo?.map(x =>
                                                        x.diag_name_pathology)?.join(', ') || '-'
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column min-width="150px" align="center" label="手术情况">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row?.inhosLungInfo?.map(x =>
                                                        x.surgery_name_main)?.join(', ') || '-'
                                                        }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column min-width="248px" align="center" label="项目">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.examReportInfo?.reportName || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="115px" align="center" label="报告编号">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.examReportInfo?.reportCode || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="来源">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.fromSource || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="180px" align="center" label="科室">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.fromSourceDeptName || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="138px" align="center" label="检测时间">
                                                <template slot-scope="scope">
                                                    <span>{{ getParsedTime(scope.row?.refTime) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column fixed="right" align="center" label="操作" width="360">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="codiag(scope.row)">一键协诊</el-button>
                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">查看档案</el-button>
                                                    <el-button v-if="scope.row.manageStatus === 'ACTIVE'"
                                                        style="margin-left: 8px; align-self: center" type="text"
                                                        @click="handleTerminateManagement(scope.row)">终止管理</el-button>
                                                    <el-button v-else style="margin-left: 8px; align-self: center"
                                                        type="text" @click="bringUnderManagement(scope.row)">纳入管理
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total1 > 0" :total="total1" :page.sync="listQuery1.pageNum"
                                            :limit.sync="listQuery1.pageSize"
                                            @pagination="handleTabsClick({ name: '2' })" />
                                    </el-row>
                                </el-tab-pane>

                                <el-tab-pane label="复查通知" name="5">
                                    <el-row>
                                        <el-input style="width: 220px;" v-model="listQuery5.patientName">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-input style="width: 200px; margin-left: 20px;"
                                            v-model="listQuery5.recordNo">
                                            <template slot="prepend">登记号</template>
                                        </el-input>
                                        <span style="margin-left: 18px;color: #909399;font-size: 14px;">复查到期时间：</span>
                                        <el-date-picker style="margin-left: 0px;" v-model="reviewDateRange"
                                            type="daterange" align="right" unlink-panels range-separator="至"
                                            start-placeholder="开始日期" end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '5' })">查询</el-button>
                                        <el-button type="primary" plain style="margin-left: 10px;"
                                            @click="handleReset5">重置</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table v-loading="listLoading" :data="list5" height="310px" border fit
                                            highlight-current-row style="width: 100%; margin-top: 20px">
                                            <el-table-column width="100px" align="center" label="姓名">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.patientName }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="登记号">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.recordNo || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <!-- <el-table-column min-width="180" align="center" label="身份证号">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.idcard }}</span>
                                                </template>
                                            </el-table-column> -->

                                            <el-table-column width="60px" align="center" label="性别">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="60px" align="center" label="年龄">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="center" label="联系方式" min-width="180">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="center" label="管理标签" width="120">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row?.diseaseGroup || '' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="248px" align="center" label="项目">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.examReportInfo?.reportName || '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="130px" align="center" label="期间来院日期">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.periodVisitDates || '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="220px" align="center" label="期间 CT 检查">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.periodCtExams || '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column min-width="138px" align="center" label="复查到期时间">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.reviewExpireTime ? getParsedTime(scope.row.reviewExpireTime) : '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column fixed="right" align="center" label="操作" width="330">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="codiagDetail(scope.row)">
                                                        协诊详情
                                                    </el-button>

                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        :class="{ 'review-action-hint': hasInterimVisitOrCt(scope.row) }"
                                                        @click="patientFollowup(scope.row)">
                                                        一键随访
                                                    </el-button>

                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">
                                                        查看档案
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total5 > 0" :total="total5" :page.sync="listQuery5.pageNum"
                                            :limit.sync="listQuery5.pageSize"
                                            @pagination="handleTabsClick({ name: '5' })" />
                                    </el-row>
                                </el-tab-pane>
                                <el-tab-pane label="待管理患者" name="4">
                                    <el-row>
                                        <el-input style="width: 300px;" v-model="listQuery4.name">
                                            <template slot="prepend">患者姓名</template>
                                        </el-input>
                                        <el-input style="width: 300px; margin-left: 20px;"
                                            v-model="listQuery4.recordNo">
                                            <template slot="prepend">登记号</template>
                                        </el-input>
                                        <el-button type="primary" style="margin-left: 20px;"
                                            @click="handleTabsClick({ name: '4' })">查询</el-button>
                                    </el-row>
                                    <el-row>
                                        <el-table ref="multipleTable" v-loading="listLoading" :data="list4"
                                            height="310px" border fit highlight-current-row
                                            style="width: 100%; margin-top: 20px">
                                            <el-table-column align="center" label="姓名" width="100px">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.name }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="120px" align="center" label="登记号">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.recordNo || '-' }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="性别" min-width="60">
                                                <template slot-scope="scope">
                                                    <span>{{ getGender(scope.row.gender) }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="年龄" min-width="60">
                                                <template slot-scope="scope">
                                                    <span>{{ getAge(scope.row.birthday) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column width="170px" align="center" label="身份证号" min-width="180">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.idcard }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="疾病标签">
                                                <template slot-scope="scope">
                                                    <span :class="scope.row.label0">糖</span>
                                                    <span :class="scope.row.label1">压</span>
                                                    <span :class="scope.row.label2">尿</span>
                                                    <span :class="scope.row.label3">脂</span>
                                                    <span :class="scope.row.label4">重</span>
                                                    <span :class="scope.row.label5">肺</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="最后来院时间" min-width="130">
                                                <template slot-scope="scope">
                                                    <span>{{ getStandardDate(scope.row.visitTime) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column align="center" label="联系方式" min-width="90">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.phone || '-' }}</span>
                                                </template>
                                            </el-table-column>

                                            <!-- <el-table-column align="center" label="状态" min-width="90">
                                                <template slot-scope="scope">
                                                    <span>{{ scope.row.integrateManageStatus || '-' }}</span>
                                                </template>
                                            </el-table-column> -->

                                            <el-table-column fixed="right" align="center" label="操作" width="200">
                                                <template slot-scope="scope">
                                                    <el-button style="margin-left: 0px; align-self: center" type="text"
                                                        @click="patientsDetail(scope.row)">查看档案</el-button>

                                                    <el-button style="margin-left: 8px; align-self: center" type="text"
                                                        @click="openManagementPlan(scope.row)">
                                                        管理方案
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <pagination v-show="total4 > 0" :total="total4" :page.sync="listQuery4.pageNum"
                                            :limit.sync="listQuery4.pageSize"
                                            @pagination="handleTabsClick({ name: '4' })" style="margin-top: 0px;" />
                                    </el-row>
                                </el-tab-pane>
                            </el-tabs>
                        </el-card>
                        <!-- 查看档案 -->
                        <patientLungDetail v-if="patientDetailVisible" ref="PatientDetailRef" />
                        <!-- <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail> -->
                        <!-- 一体化 -->
                        <patient-integration-detail v-if="patientIntegrationDetailVisible"
                            ref="patientIntegrationDetailRef"></patient-integration-detail>
                        <!-- 一键协诊 -->
                        <codiagnosisModal @upDataList="handleUpdate" v-if="codiagnosisModalVisible"
                            ref="codiagnosisModalRef">
                        </codiagnosisModal>
                        <!-- 随访 -->
                        <followupModal @upDataList="handleUpdate" v-if="followupModalVisible" ref="followupModalRef">
                        </followupModal>
                        <!-- 肺癌管理方案 -->
                        <managementPlanModal v-if="managementPlanModalVisible" ref="managementPlanRef"
                            @upDataList="handleUpdate" />

                        <!-- 终止管理弹窗 -->
                        <el-dialog title="终止管理" :visible.sync="terminateDialogVisible" width="500px"
                            :close-on-click-modal="false" @close="terminateDialogClosed">
                            <el-form :model="terminateForm" :rules="terminateRules" ref="terminateFormRef">
                                <el-form-item label="患者姓名" label-width="100px">
                                    <span>{{ terminatePatientName }}</span>
                                </el-form-item>
                                <el-form-item label="终止原因" prop="reason" label-width="100px">
                                    <el-input type="textarea" v-model="terminateForm.reason" :rows="4"
                                        placeholder="请输入终止管理的原因" maxlength="500" show-word-limit>
                                    </el-input>
                                </el-form-item>
                            </el-form>
                            <span slot="footer">
                                <el-button @click="terminateDialogVisible = false">取消</el-button>
                                <el-button type="danger" @click="confirmTerminate" :loading="terminateLoading">确认终止</el-button>
                            </span>
                        </el-dialog>
                    </el-row>
                </el-row>
            </el-card>
        </el-container>
    </div>
</template>

<script>
import {
    getAppDiabetSpecData,
    postMyListCodiag,
    getByIdCoDiag,
    getSearchListByLabel,
    turnToPageListByLabel,
    getSysDicList,
    getListByTime,
    getFollowupValue,
    getSearchList,
    turnToListByTime,
    getDoctorListQlyyDepts
} from "@/api/health/Patients";
import {
    getMessageWorkList,
    getWarnPatientMessageWorkList,
    getBusinessMonitorList,
    updateMsgStatus,
    getBusinessHomeTips
} from "@/api/health/integrationQuery";

import moment from "moment";
import { postTerminateManagement } from "@/api/health/Lung";

import integrationCoDiagDialog from "./integrationCoDiagDialog.vue"
import patientWarnMessageDialog from "./patientWarnMessageDialog.vue";
import Pagination from "@/components/Pagination";
import consultationDetailDialog from "../collaborativeManagement/bloodGlucoseCollaborative/glucoseRecordDialogs/consultationDetailDialog.vue"
import patientDetail from "@/views/patient/patientDetail";
import patientIntegrationDetail from "../integrationManagement/patientIntegrationDetail.vue";
import codiagDiag from "./codiagDiag.vue";
import bloodEditFollowUp from "../followup/bloodEditFollowUp.vue";
import codiagnosisModal from "../../components/codiagnosisModal/index.vue";
import followupModal from "../../components/followupModal/index.vue";
import patientLungDetail from "../patientLung/patientLungDetail.vue";
import managementPlanModal from "../../components/managementPlanModal/index.vue";

export default {
    components: {
        Pagination,
        patientDetail,
        integrationCoDiagDialog,
        patientWarnMessageDialog,
        consultationDetailDialog,
        patientIntegrationDetail,
        codiagDiag,
        bloodEditFollowUp,
        codiagnosisModal,
        followupModal,
        patientLungDetail,
        managementPlanModal
    },
    data() {
        return {
            activeName: '2',
            patientDetailVisible: false,
            patientIntegrationDetailVisible: false,
            patientWarnMessageDialogVisible: false,
            codiagnosisModalVisible: false,
            managementPlanModalVisible: false,
            terminateDialogVisible: false,
            terminatePatientName: '',
            terminateCurrentIdcard: '',
            terminateForm: { reason: '' },
            terminateRules: { reason: [{ required: true, message: '请输入终止管理原因', trigger: 'blur' }] },
            terminateLoading: false,
            // 随访
            patientDetailVisible: false,
            followupModalVisible: false,
            //
            valueData1: null,
            // 危急值，协诊，协诊后回访
            list1: [],
            total1: 0,
            listQuery1: {
                idcard: null,
                patientName: null,
                recordNo: null,
                fromSource: null,
                fromSourceDeptId: null,
                codiagServiceName: null,
                serviceName: null,
                type: null,
                isIntegrateManage: null,
                noVisitHoursStart: null,
                noVisitHoursEnd: null,
                codiagHospital: null,
                codiagStatus: null,
                codiagStartTime: null,
                codiagEndTime: null,
                codiagDealResult: null,
                pageNum: 1,
                pageSize: 10,
                isCritical: 1,
                taskStatus: "协诊"
            },
            list: [],
            total: 0,
            listLoading: false,
            listQuery: {
                name: null,
                visitTimeStart: '2020-01-01',
                visitTimeEnd: '2099-01-01',
                pageNum: 0,
                pageSize: 10,
                labels: [],
                integrateManageStatus: "已管理"
            },
            // 患者待管理
            list4: [],
            total4: 0,
            listQuery4: {
                name: null,
                recordNo: null,
                visitTimeStart: null,
                visitTimeEnd: null,
                pageNum: 0,
                pageSize: 10,
                labels: [],
                planExists: "false",
                limitLabels: ["lungcancer", "lungcancer_danger", "lungcancer_danger_tumor", "lungcancer_danger_mass", "lungcancer_danger_nodule", "lungcancer_danger_nodule_low", "lungcancer_danger_nodule_high"],
                labelEffectiveTimeStart: "2026-06-01",
                sortField: "visit_time",
                sortOrder: "desc"
            },
            // 复查通知
            list5: [],
            total5: 0,
            reviewDateRange: null,
            listQuery5: {
                startTime: null,
                endTime: null,
                reviewStartTime: null,
                reviewEndTime: null,
                recordNo: null,
                patientName: null,
                serviceName: "肺结节随访",
                type: "复查通知"
            },
            riskTotal: 0,
            riskListLoading: false,
            riskList: null,
            riskPatientName: null,
            riskRecordNo: null,
            riskFromSource: null,
            riskDeptIds: [],
            riskDateRange: null,
            riskListQuery: {
                pageNum: 1,
                pageSize: 10,
                codiagServiceName: "肺结节协诊",
                isCritical: 1,
                taskStatus: "协诊"
            },
            businessTotal: 0,
            businessListLoading: false,
            businessList: null,
            businessListQuery: {
                type: null,
                page: 1,
                pageSize: 10
            },
            deptsOptions: [],
            deptIds1: [],
            sexOptions: [],
            sourceOptions: [], // 指标来源
            countCritialCodiag: 0, // 危急值处理
            countCodiag: 0, // 协诊任务
            countCodiagCallback: 0, // 协诊后回访
            countIntegrateService: 0, // 患者待管理
            countFollowup: 0, // 随访
            timer: null,
        };
    },
    created() {
        this.getSystemDictList("性别");
        this.getSourceSystemDictList("指标来源");
        this.getMasterData('depts');

        // 初始协诊列表
        this.handleTabsClick({ name: "2" });

        this.getList();
        this.getRiskList();
        this.getBusinessTips();
        this.startTimer();
    },
    beforeDestroy() {
        clearInterval(this.timer); // 在组件销毁前清除定时器
    },
    methods: {
        async getMasterData(field, params) {
            try {
                if (field === 'depts') {
                    const res = await getDoctorListQlyyDepts({})
                    if (res.msg == "success") {
                        this.deptsOptions = [{ label: '全部', value: null }, ...res.data?.map(x => ({ label: x.deptName, value: x.deptId })) || []];
                    }
                }
            } catch (err) {
                console.warn(err);
            }
        },
        // 打开肺癌管理方案页面
        openManagementPlan(row) {
            this.managementPlanModalVisible = true;
            row['isModify'] = true;
            this.$nextTick(() => {
                this.$refs["managementPlanRef"].init(row);
            });
        },
        // 纳入管理：打开生成管理方案弹窗（新增）
        bringUnderManagement(row) {
            this.managementPlanModalVisible = true;
            this.$nextTick(() => {
                this.$refs["managementPlanRef"].init(row);
            });
        },
        // 终止管理
        handleTerminateManagement(row) {
            this.terminatePatientName = row.patientName || row.name || '';
            this.terminateCurrentIdcard = row.idcard || '';
            this.terminateForm.reason = '';
            this.terminateDialogVisible = true;
            this.$nextTick(() => {
                this.$refs['terminateFormRef']?.clearValidate();
            });
        },
        confirmTerminate() {
            this.$refs['terminateFormRef'].validate((valid) => {
                if (!valid) return;
                this.terminateLoading = true;
                postTerminateManagement({
                    idcard: this.terminateCurrentIdcard,
                    reason: this.terminateForm.reason
                }).then(res => {
                    if (res.msg === 'success') {
                        this.$message.success('终止管理成功');
                        this.terminateDialogVisible = false;
                        this.handleTabsClick({ name: '2' }); // 刷新列表
                    } else {
                        this.$message.error(res.msg || '终止管理失败');
                    }
                }).catch(err => {
                    console.error(err);
                    this.$message.error('终止管理失败');
                }).finally(() => {
                    this.terminateLoading = false;
                });
            });
        },
        terminateDialogClosed() {
            this.terminateForm.reason = '';
            this.$refs['terminateFormRef']?.clearValidate();
        },
        startTimer() {
            this.timer = setInterval(this.getRiskList, 300000); // 5分钟刷新一次
            console.log("风险预警刷新");
        },
        getBusinessTips() {
            getBusinessHomeTips().then(res => {
                if (res.msg == "success") {
                    var data = res.data[0];
                    this.countCritialCodiag = data.countCritialCodiag;
                    this.countCodiag = data.countCodiag;
                    this.countCodiagCallback = data.countCodiagCallback;
                    this.countIntegrateService = data.countIntegrateService;
                    this.countFollowup = data.countFollowup;
                }
            }).catch(err => {
                console.warn(err);
            })
        },
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records;
            }).catch(err => {
                console.log(err);
            })
        },
        getSourceSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sourceOptions = records?.map(x => ({ label: x.name, value: x.name }));
                this.sourceOptions = [{ label: "全部", value: null }, ...this.sourceOptions]
            }).catch(err => {
                console.log(err);
            })
        },
        getRiskList() {
            // 从无数据到有数据时显示loading，已有数据后轮询不再显示loading
            if (!this.riskList || this.riskList.length === 0) {
                this.riskListLoading = true;
            }
            postMyListCodiag({
                ...this.riskListQuery,
                patientName: this.riskPatientName ? this.riskPatientName : null,
                recordNo: this.riskRecordNo ? this.riskRecordNo : null,
                fromSource: this.riskFromSource,
                fromSourceDeptId: this.riskDeptIds.length ? this.riskDeptIds.join(',') : null,
                refStartTime: this.riskDateRange ? this.getParseDate(this.riskDateRange[0], 1) : null,
                refEndTime: this.riskDateRange ? this.getParseDate(this.riskDateRange[1], 2) : null
            }).then((res) => {
                this.riskListLoading = false;
                this.listLoading = false;
                if (res.msg == "success") {
                    this.riskList = res.data.records;
                    this.riskTotal = res.data.total;
                }
            });
        },
        // 风险预警筛选重置
        handleResetRisk() {
            this.riskPatientName = null;
            this.riskRecordNo = null;
            this.riskFromSource = null;
            this.riskDeptIds = [];
            this.riskDateRange = null;
            this.riskListQuery.pageNum = 1;
            this.getRiskList();
        },
        //患者风险预警列表
        patientWarnMessageList(data) {
            this.updateWarnMsgStatus(data);

            this.patientWarnMessageDialogVisible = true;
            data['isLung'] = true;
            this.$nextTick(() => {
                this.$refs['patientWarnMessageDialogRef'].init(data);
            })
        },
        updateWarnMsgStatus(data) {
            if (data.msgStatus == null) {
                var query = {
                    id: data.id,
                    msgStatus: 1
                }
                updateMsgStatus(query).then((res) => {
                    if (res.msg == "success") {
                        this.getRiskList();
                    }
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        //一体化方案
        patientIntegrationDetail(row) {
            this.patientIntegrationDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["patientIntegrationDetailRef"].init(row);
            });
        },
        //管理队列 协诊完成之后刷新列表
        upDataList() {
            this.getList();
        },
        handleTabsClick(props) {
            const { name, type, ...params } = props;
            if (type === 'click') {
                this.listQuery1.pageNum = 1;
                this.listQuery1.patientName = null;
                this.listQuery1.recordNo = null;
            }
            if (name === '1') {
                // console.warn('危急值处理')
                this.activeName = name;
                this.getList1({ isCritical: 1, taskStatus: "协诊", ...params });
            }
            if (name === '2') {
                // console.warn('协诊任务')
                this.activeName = name;
                this.listQuery1.fromSourceDeptId = this.deptIds1.length ? this.deptIds1.join(',') : null;
                this.getList1({
                    isCritical: 0, taskStatus: "协诊", codiagServiceName: "肺结节协诊", recordNo: this.listQuery1.recordNo ? this.listQuery1.recordNo : null,
                    refStartTime: this.valueData1 ? this.getParseDate(this.valueData1[0], 1) : null,
                    refEndTime: this.valueData1 ? this.getParseDate(this.valueData1[1], 2) : null,
                    ...params
                });
            }
            // if (name === '3') {
            //     // console.warn('协诊后回访')
            //     this.activeName = name;
            //     this.getList1({ isCritical: undefined, taskStatus: "回访", ...params });
            // }
            if (name === '4') {
                // console.warn('患者待管理')
                this.activeName = name;
                this.getList4();
            }
            if (name === '5') {
                // console.warn('随访任务')
                this.activeName = name;
                this.listQuery5.reviewStartTime = this.reviewDateRange ? this.reviewDateRange[0] : null;
                this.listQuery5.reviewEndTime = this.reviewDateRange ? this.reviewDateRange[1] : null;
                this.getList5();
            }
        },
        // 一键协诊后，刷新列表
        handleUpdate() {
            this.handleTabsClick({ name: this.activeName })
        },
        handleClick(tab, event) { },
        hasInterimVisitOrCt(row) {
            return Boolean(row && (row.periodVisitDates || row.periodCtExams));
        },
        getList1(props) {
            this.listLoading = true;
            postMyListCodiag({ ...this.listQuery1, ...props }).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list1 = res.data.records;
                    this.total1 = res.data.total;
                    this.list1.forEach((item, index) => {
                        this.list1[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list1[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list1[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list1[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list1[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list1[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 已管理
        getList() {
            this.listLoading = true;

            if (this.doctorName == "韩明宏") {
                var limitLabels = ["lungcancer", "lungcancer_danger_nodule", "lungcancer_danger_mass", "lungcancer_danger_tumor"];
                this.listQuery.limitLabels = limitLabels;
            }

            this.listQuery.mobileExist = null;

            getSearchListByLabel(this.listQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list = res.data.records;
                    this.total = res.data.total;
                    this.list.forEach((item, index) => {
                        this.list[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                        //followupTypes,根据标签得出支持的随访类型
                        this.list[index].followupTypes = this.setFollowupTypes(item)
                    });
                }
            });
        },
        // 待管理
        getList4() {
            this.listLoading = true;

            this.listQuery4.limitLabels = ["lungcancer", "lungcancer_danger", "lungcancer_danger_tumor", "lungcancer_danger_mass", "lungcancer_danger_nodule", "lungcancer_danger_nodule_low", "lungcancer_danger_nodule_high"];
            this.listQuery4.labelEffectiveTimeStart = "2026-06-01";

            this.listQuery4.mobileExist = null;

            getSearchListByLabel({ ...this.listQuery4, recordNo: this.listQuery4.recordNo ? this.listQuery4.recordNo : null, }).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list4 = res.data.records;
                    this.total4 = res.data.total;
                    this.list4.forEach((item, index) => {
                        this.list4[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list4[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list4[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list4[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list4[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list4[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 复查通知重置
        handleReset5() {
            this.listQuery5.patientName = null;
            this.listQuery5.recordNo = null;
            this.reviewDateRange = null;
            this.listQuery5.reviewStartTime = null;
            this.listQuery5.reviewEndTime = null;
            this.getList5();
        },
        // 复查通知
        getList5() {
            this.listLoading = true;
            turnToListByTime({ ...this.listQuery5, recordNo: this.listQuery5.recordNo ? this.listQuery5.recordNo : null, }).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    this.list5 = res.data.records;
                    this.total5 = res.data.total;
                    this.list5.forEach((item, index) => {
                        this.list5[index].label0 = this.setLabel0(item)
                            ? this.setLabel0(item)
                            : "labelNone";
                        this.list5[index].label1 = this.setLabel1(item)
                            ? this.setLabel1(item)
                            : "labelNone";
                        this.list5[index].label2 = this.setLabel2(item)
                            ? this.setLabel2(item)
                            : "labelNone";
                        this.list5[index].label3 = this.setLabel3(item)
                            ? this.setLabel3(item)
                            : "labelNone";
                        this.list5[index].label4 = this.setLabel4(item)
                            ? this.setLabel4(item)
                            : "labelNone";
                        this.list5[index].label5 = this.setLabel5(item)
                            ? this.setLabel5(item)
                            : "labelNone";
                    });
                }
            });
        },
        // 复查通知-协诊详情：优先匹配本次复查对应的协诊，匹配不到则打开该患者最后一次协诊
        codiagDetail(row) {
            postMyListCodiag({
                codiagServiceName: "肺结节协诊",
                idcard: row.idcard,
                codiagStatus: "完成",
                pageNum: 1,
                pageSize: 100
            }).then((res) => {
                if (res.msg != "success" || !res.data || !res.data.records || res.data.records.length === 0) {
                    this.$message.warning("该患者暂无协诊记录");
                    return;
                }
                let records = res.data.records;
                // 1. 优先精确匹配：协诊复查到期时间(record.reviewTime) == 本次复查通知到期时间(reviewExpireTime)
                let target = null;
                if (row.reviewExpireTime) {
                    const expireDay = moment(row.reviewExpireTime).format("YYYY-MM-DD");
                    target = records.find(x =>
                        x.record && x.record.reviewTime &&
                        moment(x.record.reviewTime).format("YYYY-MM-DD") === expireDay
                    );
                }
                // 2. 匹配不到则取该患者最后一次协诊（按协诊/报告时间倒序取最新）
                if (!target) {
                    const sorted = [...records].sort((a, b) =>
                        new Date(b.codiagTime || b.refTime || 0) - new Date(a.codiagTime || a.refTime || 0)
                    );
                    target = sorted[0];
                }
                this.codiagnosisModalVisible = true;
                target['isRead'] = true;
                this.$nextTick(() => {
                    this.$refs['codiagnosisModalRef'].init(target);
                });
            }).catch((err) => {
                console.error(err);
                this.$message.error("查询协诊详情失败");
            });
        },
        //随访
        patientFollowup(row) {
            this.followupModalVisible = true;
            this.$nextTick(() => {
                this.$refs["followupModalRef"].init(row);
            });
        },
        // 跳转至相应病人档案详情页
        patientsDetail(row) {
            this.patientDetailVisible = true;
            this.$nextTick(() => {
                this.$refs["PatientDetailRef"].init(row);
            });
        },
        //一键协诊
        codiag(row) {
            this.codiagnosisModalVisible = true;
            this.$nextTick(() => {
                this.$refs['codiagnosisModalRef'].init(row);
            })
        },
        /** 糖尿病 */
        setLabel0(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "diabet");
                const isIncluded2 = labels.some(dt => dt.label === "diabet_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_diabet");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高血压 */
        setLabel1(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "hyper");
                const isIncluded2 = labels.some(dt => dt.label === "hyper_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyper");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高尿酸 */
        setLabel2(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "hyperuricemia");
                const isIncluded2 = labels.some(dt => dt.label === "hyperuricemia_danger");
                const isIncluded3 = labels.some(dt => dt.label === "easy_hyperuricemia");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高血脂 */
        setLabel3(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "bloodfat");
                const isIncluded2 = labels.some(dt => dt.label === "bloodfat_danger");

                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        /** 高体重 */
        setLabel4(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "overweight");

                if (isIncluded) {
                    return "labelRed"
                }
            } else {
                return "labelNone";
            }
        },
        /** 慢阻肺 肺癌管理 */
        setLabel5(item) {
            var labels = item.labels;
            if (labels != null && labels.length > 0) {
                const isIncluded = labels.some(dt => dt.label === "lungcancer");
                const isIncluded2 = labels.some(dt => dt.label === "lungcancer_danger_nodule" || dt.label === "lungcancer_danger_mass" || dt.label === "lungcancer_danger_tumor");
                const isIncluded3 = labels.some(dt => dt.label === "easy_lungcancer");

                // lungcancer_danger_nodule 肺结节
                // lungcancer_danger_mass 肺占位
                // lungcancer_danger_tumor 肺肿瘤
                if (isIncluded) {
                    return "labelRed"
                }

                if (isIncluded2) {
                    return "labelRedCircle"
                }
            } else {
                return "labelNone";
            }
        },
        setFollowupTypes(item) {
            var labels = item.labels;
            var followupTypes = [];
            if (labels != null && labels.length > 0) {

                var isIncluded = labels.some(dt => dt.label === "diabet" || dt.label === "diabet_danger");
                if (isIncluded) followupTypes.push("糖尿病随访");

                isIncluded = labels.some(dt => dt.label === "hyper" || dt.label === "hyper_danger");
                if (isIncluded) followupTypes.push("高血压随访");

                isIncluded = labels.some(dt => dt.label === "bloodfat" || dt.label === "bloodfat_danger");
                if (isIncluded) followupTypes.push("高血脂随访");
            }
            return followupTypes;
        },
        getGender(gender) {
            var option = this.sexOptions.filter(v => v.value == gender)[0];
            return option.name;
        },
        // 计算当前年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
        // 日期格式转化
        getParseDate(time, type) {
            if (type == 1) {
                var newTime = new Date(time);
            } else if (type == 2) {
                var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
            }
            // 获取完整的年份(4位)
            var year = newTime.getFullYear();
            // 获取月份(0-11,0代表1月)
            var month = newTime.getMonth() + 1;
            // 获取日期(1-31)
            var date = newTime.getDate();

            return (
                year +
                "-" +
                (month < 10 ? "0" + month : month) +
                "-" +
                (date < 10 ? "0" + date : date)
            );
        },
        getParsedTime(time) {
            if (!time) {
                return '-'
            }
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getStandardDate(dateString) {
            if (!dateString) return null;
            const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
            return formattedDate;
        },
        getDetailedRemainingTime(time) {
            if (!time) {
                return '0'
            }

            const now = moment();
            const endTime = moment(time);

            // 计算时间差（毫秒）
            const diffMs = endTime.diff(now);

            // 如果已过期
            if (diffMs <= 0) {
                return '0';
            }

            // 转换为小时并保留1位小数
            const remainingHours = diffMs / (1000 * 60 * 60);
            return `${remainingHours.toFixed(0) || 0}`;
        }
    },
};
</script>

<style>
.box-card {
    width: 1443px;
}

.elCard .el-tabs__header {
    display: none !important;
}

.customCard {
    margin: 0px 5px 10px 0px;
    padding-bottom: 10px;
}

.customCard .el-row {
    display: flex;
    gap: 6px;
}

.customCard .el-card__body {
    padding: 10px;
}

.card-panel-col {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
}

.card-panel-icon-wrapper {
    display: flex;
    width: 60px;
    height: 60px;
    flex-direction: column;
    justify-content: center;
    /* 水平居中*/
    align-items: center;
    margin-bottom: 10px;
}

.image {
    width: 50px;
    height: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
}

.cardImage1 {
    width: 60px;
    height: 60px;
}

.cardImage2 {
    width: 65px;
    height: 65px;
}

.card-panel-icon-wrapper2 {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    /* 水平居中*/
    align-items: center;
    margin-bottom: 10px;
}

.image2 {
    width: 50px;
    height: 50px;
    margin-left: 10px;
    display: flex;
    justify-content: center;
    /* 水平居中*/
    align-items: center;
}

.cardColorBlue {
    background: linear-gradient(to right, #9fccfc, #618bff);
}

.cardColorPurple {
    background: linear-gradient(to right, #a4aefc, #6089ff);
}

.cardColorGreen {
    background: linear-gradient(to right, #9ad2e7, #74bfdc);
}

.cardColorSkyBlue {
    background: linear-gradient(-89.83deg, rgba(122, 184, 251, 1) 1.16%, rgba(145, 213, 255, 0.5) 99.16%) !important;
}

.cardColorDefault {
    background: linear-gradient(-89.83deg, rgba(187, 187, 187, 0.74) 1.16%, rgba(187, 187, 187, 1) 99.16%);
}

.el-progress-bar__inner {
    background-color: unset;
    background-image: linear-gradient(to right, #6855ff, #5aa2eb);
}

.item {
    margin-top: 10px;
    margin-right: 40px;
}

.custom-icon {
    font-size: 36px;
    color: #fff;
    opacity: 0.75;
}

.risk-icon {
    font-size: 24px;
    color: red;
    opacity: 0.75;
    display: flex;
    align-items: center;
    margin-top: 10px;
}


.labelRed {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
    /* padding: 3px; */
}

.labelRedCircle {
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid red;
    background: #fff;
    color: red;
    display: inline-block;
    /* padding: 2px; */
}

.labelBlue {
    border-radius: 50%;
    color: white;
    background: blue;
    padding: 3px;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelPurple {
    border: 1px solid purple;
    background: purple;
    color: #fff;
    padding: 2px;
    border-radius: 50%;
}

.labelNone {
    display: none;
}

.review-action-hint {
    color: #c0c4cc;
}
</style>
